// The two faces of an order's conversation: the buyer (their picture, else a
// person icon) and the seller (its logo, else a shop icon). Used by the
// seller's order page; the storefront draws its own with the same rules.
import React, { useEffect, useState } from "react"
import { UserIcon, BuildingStorefrontIcon } from "@heroicons/react/24/solid"
import { twMerge } from "tailwind-merge"
import { url as cmsUrl } from "aldoo-ra/CMS/url"
import { orgLogoUrl } from "aldoo-ra/Organizations/api"

/** A user's photo url, or null: the old site's cartoon avatars (`avatar_<n>`) are no photo. */
export function photoOf(person) {
  const value = String(person?.avatar || "").trim()
  if (!value || /^avatar_\d+$/.test(value)) return null
  if (/^(https?:|data:|blob:)/.test(value) || value.startsWith("//")) return value
  const version = person?.avatarUpdatedAt ? new Date(person.avatarUpdatedAt).getTime() : 0
  return `${cmsUrl(value)}${version ? `?t=${version}` : ""}`
}

/** An organization's logo url, or null. */
export const logoOf = (seller) => (seller?._id && seller.logo ? orgLogoUrl(seller._id, seller.logoUpdatedAt) : null)

/** A round picture, or the icon in its place when there is none (or it fails to load). */
function Round({ src, Icon, size, className }) {
  const [failed, setFailed] = useState(false)
  useEffect(() => setFailed(false), [src])
  const box = { width: size, height: size }
  if (src && !failed) return <img src={src} alt="" style={box} className={twMerge("rounded-full object-cover shrink-0 bg-white border border-black/10", className)} onError={() => setFailed(true)} referrerPolicy="no-referrer" />
  return (
    <span style={box} className={twMerge("rounded-full shrink-0 inline-flex items-center justify-center bg-black/10 text-black/55", className)} aria-hidden>
      <Icon style={{ width: size * 0.58, height: size * 0.58 }} />
    </span>
  )
}

export const BuyerAvatar = ({ person, size = 32, className = "" }) => <Round src={photoOf(person)} Icon={UserIcon} size={size} className={className} />
export const SellerAvatar = ({ seller, size = 32, className = "" }) => <Round src={logoOf(seller)} Icon={BuildingStorefrontIcon} size={size} className={className} />
